/** Guest orders have no buyer user — customer data comes from checkout + shipping. */
export function orderCustomerSummary(order) {
  if (order?.customer) {
    return order.customer;
  }

  const buyer = order?.buyer;
  if (buyer) {
    const name = `${buyer.first_name || ''} ${buyer.last_name || ''}`.trim();
    return {
      type: 'registered',
      email: buyer.email || null,
      name: name || null,
      phone: buyer.phone_number || null,
    };
  }

  const address = order?.shippingAddress || order?.shipping_address;
  const pending = order?.pendingCheckout || order?.pending_checkout;

  return {
    type: 'guest',
    email: pending?.guest_email || null,
    name: address?.full_name || null,
    phone: address?.phone_number || null,
  };
}

export function orderCustomerListLabel(order) {
  const customer = orderCustomerSummary(order);
  return customer.email || customer.name || 'Guest';
}
